import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, UrlTree } from '@angular/router';
import { QueryParameterModel } from '../models/query-parameter.model';

@Injectable({
  providedIn: 'root',
})
export class QueryParameterGuard implements CanActivate {
  constructor(private readonly router: Router) {}

  canActivate(route: ActivatedRouteSnapshot): boolean | UrlTree {
    const model = route.data[QueryParameterModel.KEY] as QueryParameterModel;
    const actualQueryParameters = route.queryParamMap;
    const allParametersSet = model.keys.every((key) => actualQueryParameters.get(key) !== null);

    if (allParametersSet) {
      return true;
    } else {
      return this.router.createUrlTree([model.url]);
    }
  }
}
